import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Button, Dropdown, Grid, Icon, Popup} from 'semantic-ui-react'
import productFolderListStore from "../../Stores/ProductFolderListStore";
import {InformationPanelItem} from "../Dashboard/InformationPanelItem";
import templateByFoldersStore from "../../Stores/TemplateByFoldersStore";
import templateLookupStore from "../../Stores/TemplateLookupStore";
import CheckboxWithTip from "../Dashboard/CheckboxWithTip";
import TextField from "../Shared/TextField";

function TemplateMappingBlock() {
    useEffect(() => {
        void productFolderListStore.load();
        void templateLookupStore.load();
    }, []);
    return (
        <>
            <InformationPanelItem header='Связь групп товаров с шаблонами'>
                <Grid verticalAlign='middle'>
                    <Grid.Row style={{marginBottom: 0, paddingBottom: 0}}>
                        <Grid.Column width={9}>
                            <Dropdown fluid
                                      selection
                                      options={productFolderListStore.folders.filter(x => !x.templateName).map((template) => {
                                          return {text: template.name, value: template.id}
                                      })}
                                      placeholder='Выберите группу'
                                      search
                                      value={templateByFoldersStore.folders}
                                      onChange={(_, data) => templateByFoldersStore.folders = data.value ? (data.value as string[]) : []}
                                      error={templateByFoldersStore.trySave && templateByFoldersStore.folders.length === 0}
                                      multiple
                                      noResultsMessage={'Нет групп'}
                                      clearable
                            />
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <Dropdown fluid
                                      selection
                                      options={templateLookupStore.templates.map((template) => {
                                          return {text: template.name, value: template.id}
                                      })}
                                      placeholder='Выберите шаблон'
                                      search
                                      error={templateByFoldersStore.trySave && templateByFoldersStore.templateId === ''}
                                      value={templateByFoldersStore.templateId}
                                      onChange={(_, data) => templateByFoldersStore.templateId = data.value ? (data.value as string) : ''}
                                      clearable
                            />
                        </Grid.Column>
                        <Grid.Column verticalAlign={'middle'} width={1}>
                            <Icon fitted name='save' color={templateByFoldersStore.canSave ? 'teal' : 'grey'}
                                  style={{'cursor': 'pointer', fontSize: '1.5em'}}
                                  onClick={() => templateByFoldersStore.save()}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{marginTop: 0, paddingTop: 0}}>
                        <Grid.Column width={16}>
                            <CheckboxWithTip label={'Использовать и для вложенных групп'}
                                             tip={'Данный шаблон будет использоваться для выбранной группы и ее дочерних групп'}
                                             checked={templateByFoldersStore.useForChildren}
                                             onChange={value => templateByFoldersStore.setUseForChildren(value)}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    {productFolderListStore.folders.map((x) => x.templateName &&
                        <TextField nameWidth={9} valueWidth={7} key={x.id} name={x.name} action value={x.templateName}
                                   readOnly>
                            <input/>
                            {x.useTemplateForChildren &&
                                <Popup
                                    position={'bottom right'}
                                    content={'Используется и для вложенных групп'}
                                    trigger={<Button color={'blue'}
                                                     style={{cursor: 'help'}}
                                                     icon='sort amount down'/>
                                    }
                                />
                            }
                            <Popup
                                position={'bottom right'}
                                content={'Удалить'}
                                trigger={<Button color={'red'} icon='trash' onClick={() => templateByFoldersStore.remove(x.id)}/>}/>
                        </TextField>)}
                </Grid>
            </InformationPanelItem>
        </>
    )
}

export default observer(TemplateMappingBlock);
